import React, { useRef, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Mensaje } from '../components/mensajes';

import useTableScroll from "../components/useTableScroll";
import Controls from "../components/controls/Controls";

import { TableBody, TableRow, TableCell, InputAdornment } from '@mui/material'

;

import axios from 'axios';
import { Dimmer} from '../components/spinner';



const CatalogoTipoReten = props => {

    let op = require('../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');

    const btnCancela = useRef();
    const [mostrar, setMostrar] = useState(false);
    const [titulo, setTitulo] = useState();
    const [msg, setMsg] = useState();
    const [activate, setActivate] = useState(false);
    const [records, setRecords] = useState([]);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })
    const [values, setValues] = useState({});
    const [itemSelect, setItemSelect] = useState(-1);
    const [activo, setActivo] = useState(true);

    const headCells = [
        { id: 'idinmueble', label: 'CODIGO', width: '10px', textAlign: "center", background: "#019cd5", fontSize: "10px", color: "white" },

        { id: 'numficha', label: 'DESCRIPCIÓN', width: '130px', textAlign: "center", background: "#019cd5", fontSize: "10px", color: "white" },


    ]

    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTableScroll(records, headCells, filterFn);

    const handleSearch = e => {
        let target = e.target;

        setFilterFn({
            fn: items => {
                if (target.value === "") {
                    return items;
                } else {
                    return items.filter(x => {
                        if ((x.idtiporetencion.includes(target.value) === null ? '' : x.idtiporetencion.includes(target.value))
                            || (x.descripcion === null ? '' : x.descripcion.toLowerCase().includes(target.value.toLowerCase()))
                            /*  || (x.nombrepropie === null ? '' : x.nombrepropie.toLowerCase().includes(target.value.toLowerCase())) */
                        ) {
                            return x;
                        }
                    });
                }
            }
        })

    }

    const seleccionarTipoReten = () => {

        let endpoint = `${op.conexion}/api/administracion/catalogoreten`;

        setActivate(true);

        axios.get(endpoint, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
        }).then(function (response) {

            if (response.status === 200) {

                setRecords(response.data)
                console.log(response.data)
            }

            setActivate(false);

        }).catch(function (error) {

            setTitulo("ERROR");
            setMsg(error.response.data.message)
            setMostrar(true)
            setActivate(false);

        })

    }


    const blanquear = () => {

        setMostrar(false);
        setTitulo('');
        setMsg('');
        setActivate(false);
        setRecords([]);
        setFilterFn({ fn: items => { return items; } });
    }


    const handleCloseMensa = () => {
        setMostrar(false);
    }

    const cancelar = () => {

        blanquear();
        props.onHideCancelar();
    }

    const seleccionarLista = (index) => (event) => {
        blanquear();
       
            props.onHideAceptaCatalogo(values[0].idInmue)
      
    };


    const seleccionarFila = (index) => (event) => {

        setItemSelect(index);
        setActivo(false);

        var idInmue = recordsAfterPagingAndSorting()[index].idtiporetencion;
     

        var datos = [];

        datos.push({
            idInmue,
           
        })
        setValues(datos);
    };


    return (
        <Modal
            {...props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
            keyboard={false}
            onShow={() => {
                seleccionarTipoReten()
            }}
        >
            <Modal.Header className='azulGradiant'>
                <Modal.Title style={{ color: "#fff" }}>Seleccionar Tipo de Retención.</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Mensaje titulo={titulo} mensaje={msg}
                    show={mostrar}
                    onHide={handleCloseMensa} />
              <Dimmer active={activate} inverted>
       
      </Dimmer>
                <div className="col-md-12 m-0">

<div className="input-group input-group-sm mb-3 m-0 col-md-5">
    <input type='text'
        onChange={handleSearch} className="form-control rounded-pill search-input" />
</div>
</div>
                <div className="col-md-12" style={{ margin: "auto" }} >
                    <TblContainer >
                        <TblHead />

                        <tbody>
                            {
                                records && recordsAfterPagingAndSorting().map((item, index) => (
                                    <tr key={item.idtiporetencion} style={{ padding: "0", cursor: 'pointer', background: itemSelect === index ? "lightskyblue" : "white" }} onClick={seleccionarFila(index)}>
                                        <td style={{ fontSize: "10px", textAlign: "left", width: "10px", verticalAlign: "middle" }}>{item.idtiporetencion}</td>

                                        <td style={{ fontSize: "10px", textAlign: "left", width: "130px", verticalAlign: "middle" }}>{item.descripcion}</td>
                                        {/*                                         <td style={{ fontSize: "10px", textAlign: "left", width: "250px", verticalAlign: "middle" }}>{item.nombrepropie}</td>
                                        <td style={{ fontSize: "10px", textAlign: "left", width: "250px", verticalAlign: "middle" }}>{item.dirinmueble}</td>
                                        <td style={{ fontSize: "10px", textAlign: "left", width: "100px", verticalAlign: "middle" }}>{item.codigocatastral}</td>
                                        <td style={{ fontSize: "10px", textAlign: "left", width: "200px", verticalAlign: "middle" }}>{item.cedulapropie}</td>
                                      */}   {/*     <td align="center" style={{ fontSize: "10px", textAlign: "center", width: "120px", padding: 0, verticalAlign: "middle" }}>
                                            <button style={{ width: "120px" }} onClick={seleccionarInmueble(index)} className="btn btn-outline-info"><i className="fas fa-edit">Seleccionar</i> </button>
                                        </td> */}
                                    </tr>

                                ))
                            }
                        </tbody>

                    </TblContainer>
                    <TblPagination />

                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-sm btn-primary rounded-pill" 
                    disabled={activo} 
                    onClick={seleccionarLista()}>
                    <i className="fas fa-check-circle"> Aceptar</i> 
                </button>
                <button ref={btnCancela} 
                    onClick={cancelar} 
                    className="btn bg-light btn-sm rounded-pill">
                    <i className="fa"> Cancelar</i>
                </button>
            </Modal.Footer>
        </Modal>
    );
}

export default CatalogoTipoReten;